import { PmsBookingIntentModelBase } from "./PmsBookingIntentModel.base"


/* A graphql query fragment builders for PmsBookingIntentModel */
export { selectFromPmsBookingIntent, pmsBookingIntentModelPrimitives, PmsBookingIntentModelSelector } from "./PmsBookingIntentModel.base"

/**
 * PmsBookingIntentModel
 */
export const PmsBookingIntentModel = PmsBookingIntentModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
